import axios, { type AxiosRequestConfig } from 'axios';

const api = axios.create({ baseURL: window.API_URL });

api.interceptors.request.use(
  (options) => options,
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const doGet = <T = any>(url: string, options?: AxiosRequestConfig) =>
  api.get<T>(url, options);

export const doPost = <T = any, P = any>(url: string, data: P, options?: AxiosRequestConfig) =>
  api.post<T>(url, data, options);
